













































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Workspace, Summary, ReviewForm } from '@/entities';
import ProgressBar from '@/components/common/ProgressBar/ProgressBar.vue';
import WorkflowButtons from '@/components/common/ProgressBar/WorkflowButtons.vue';
import ValidationMessageComponent from '@/components/common/ValidationMessage/ValidationMessage.vue';
import LeftNav from '@/components/App/Modules/GMS/Workspace/Components/LeftNavigation.vue';
import AppSummary from './Components/Summary.vue';
import Reviews from './Components/Reviews.vue';
import ActivityLog from './Components/ActivityLog.vue';
import AppDocs from './Components/AppDocs.vue';

import { Utilities as utils } from '@/shared/utilities';
import { AppConstants as _app } from '@/shared/app.constants';
import { AppMenus as _menu } from '@/shared/app.menu';
import { User } from "oidc-client";
import AuthService from "@/services/auth.service";
import { Locales } from "@/i18n/locales";

const namespace: string = "application";
const auth = new AuthService();

@Component({
    components: {
        ProgressBar,
        WorkflowButtons,
        LeftNav,
        AppSummary,
        Reviews,
        ActivityLog,
        AppDocs,
        ValidationMessageComponent
    }
})
export default class AdminApplicationSummaryComponent extends Vue {

    @State(namespace) application!: Workspace;
    @State("reviewForm") review!: ReviewForm;
    @Action("getData", { namespace: "reviewForm" }) getData: any;
    @Action("getCategories", { namespace: "reviewForm" }) getCategories: any;
    @Getter("rootTemplate", { namespace }) schema: any;
    @Action("getApplication", { namespace }) getApplication: any;
    @Action("getApplicationStatus", { namespace }) getApplStatus: any;
    @Action("saveApplication", { namespace: "application" }) save: any;
    @Action("setReviewId", { namespace: "reviewExternal" }) setReviewId: any;
    @Action("setApplicationId", { namespace: "application" }) setApplication: any;
    @Getter("_appUser", { namespace: "RootApp" }) _username!: string;
    @Getter("_appUserId", { namespace: "RootApp" }) _userid!: number;
    @Action("create", { namespace: "reviewForm" }) createReview: any;

    showFlow = false;
    tagReviews = [];
    internalReview: any = {};
    id: number = 0;
    actions = _app.actions;
    subjects = _app.subjects;
    selectedKey = Object.keys(this.subSections.properties)[0];
    showSideBar = true;
    showBtns = false;
    appDataLoaded = false;
    tagLockedStatus: any = [_app.reviewStatus.Submitted, _app.reviewStatus.COI_Rejected];
    tagDownloadStatus: any = [_app.reviewStatus.Internal_In_Progress, _app.reviewStatus.Submitted, _app.reviewStatus.Internal_Submitted];
    summaryKey = 0;
    isMigrated = false;    
    userTypeId?: number = null;
    defaultLocale: string = localStorage.getItem("language") || Locales.EN;

    mounted() {
        if (!this.application || !this.$route.params.applicationId) {
            this.$router.push({
                name: "dashboard"
            });
        }
        this.selectedKey = Object.keys(this.subSections.properties)[0];

        auth.isLoggedIn().then((isLoggedIn) => {
            if (isLoggedIn) {
                auth.getUser().then((user: User) => {
                    this.userTypeId = Number(user.profile.user_type_id);                    
                });
            }
        });
    }

    sidebarToggle() {
        this.showSideBar = !this.showSideBar;
    }

    loadData(){ 
        this.getAppData();
    }

    toggleWFBtns() {
        this.showBtns = !this.showBtns;
    }

    openReview(item: any) {
        // this.setReviewId(item.externalReviewId);
        let routeData = this.$router.resolve({
            name: "viewTagReview",
            query: {
                reviewerId: item.ReviewerId,
                applicationId: item.uniqueID,
                entity: "Application"
            }
        });
        window.open(routeData.href, "_blank");
    }

    /** open a read only view of application in new tab */
    /*openApplication(applicationId, context) {
        if (context === "readonly") {
            let routeData = this.$router.resolve({
              name: "viewApplication",
              query: { appId: applicationId }
            });
            window.open(routeData.href, "_blank");
        } else {
            this.setApplication(applicationId);
            this.$router.push({
              name: "applSummary"
            });
        }
    }*/

    returnedApplication(data) {
        this.$router.push({
            name: "dashboard",
            query: {}
        });
    }

    /**  update the sub menu on left panel selection */
    subMenuChanged(selectedMenu, key) {
        this.selectedKey = key;
    }

    /** show validations */
    showValidation(msgs: any) {
        this.application.validationMessages = msgs;
        this.application.showValidationDilog = true;
    }

    // close the validation message dialog
    validationMessageClosed() {
        this.application.showValidationDilog = false;
        this.application.validationMessages = [];
        (this.$refs.workflowButtonRef as InstanceType<typeof WorkflowButtons>).enableAllButtons();
    }

    // redirect to application form on validation message click
    validationMessageClicked(msg: any) {
        this.application.showValidationDilog = false;
        this.application.validationMessages = [];
    }

    /** Download Pdf*/
    downloadPdf(item: any) {
        let self = this;
        let categoryList = [], modelData, formData;
        if (item.ExternalReviewId) {
            this.$services.review.getReportData(item.ExternalReviewId, 'Application')
                .then((resp) => {
                    if (resp.status >= 200 && resp.status < 300) {
                        this.getCategories({ id: resp.data.metadata.ApplicationId, entity: 'Application' })
                            .then((catg) => {
                                this.$services.tagReviewReport.generate({
                                    "data": resp.data.review,
                                    "categories": catg,
                                    "metadata": resp.data.metadata,
                                    "user": this._username
                                });
                            })
                    }
                });
        }
    }

    /** Review the application */
    reviewApplication(item) {
        const self = this;
        this.$router.push({
            name: "reviewApplication",
            params: {
                reviewerId: item.ReviewerId,
                applicationId: item.uniqueID,
                entity: "Application"
            }
        });
    }

    getFormData(model) {
        const reviews = Object.keys(model).reduce(
            (out: any, key: string) => {
                out.push(
                    Object.assign({}, { categoryId: parseInt(key) }, model[key])
                );
                return out;
            }, []);

        let form = {
            reviews,
            override: this.review.override,
            comment: this.review.comment,
            // totalScore: this.overallScore,
            overallRating: this.review.overallRating,
            recommendation: this.review.recommendation,
            applicationId: this.review.applicationId,
            reviewerId: this.review.reviewerId,
            version: this.review.version,
            auditInfo: this.review.auditInfo
        };

        return form;
    }

    formatCurrency(val) {
        return utils.formatCurrency(val, this.application.application.BudgetCurrency, this.defaultLocale);
    }

    updateStatus(item) {
        this.application.application.WorkflowStatusId = item.StepId;
        this.application.application.Comments = item.Comments;
        this.application.application.Subject = item.Subject;
        this.application.application.notify = item.notify;
        this.save({
            data: this.application.application,
            id: this.application.application.ApplicationId,
            context: 'workflowAction'
        }).then(() => {
            this.getApplStatus(this.application.application.ApplicationId);
            this.summaryKey += 1;
        });
    }

    rollback(e) {
        this.getApplication(this.application.application.ApplicationId).then((data) => {
            this.summaryKey += 1
        })
    }

    get subSections() {
        if (this.isMigrated) {
            return _menu.migratedAdminDashboardSections;
        }
        else {
            return _menu.adminDashboardSections;
        }
    }

    get workFlowItems() {
        return this.application.application.WorkflowInfo || {}
    }

    /** CHeck whether negotiation log exists */
    get showNegotiationLog() {
        if (this.application.application.WorkflowInfo
            && this.application.application.WorkflowInfo.LogStatus) {

            const log = this.application.application.WorkflowInfo.LogStatus
                .find(x => x.WorkflowService === 'Waiting Negotiation Response Business Rule');

            if (log)
                return true;
            else
                return false;
        } else {
            return false;
        }
    }

    getAppData(){
        const self = this;
        this.getApplication(self.id).then((data) => {
                    this.appDataLoaded = true;
                    this.isMigrated = this.application.application.IsMigrated
                    this.showFlow = true;
                    this.$services.review.getReviewSummary(self.id, 'Application').then((resp) => {
                        if (resp.Result && resp.Result === 'OK') {
                            self.tagReviews = resp.Record;
                        }
                    });
                    this.$services.reviewinternal.reviewSummary(self.id, 'Application').then((resp) => {
                        if (resp && resp.Result === 'ERROR') { // not found case
                            self.internalReview = {};
                        } else if (resp) {
                            self.internalReview = resp;
                        }
                    });
                });
    }

    /** watch method */
    @Watch("$route", { immediate: true, deep: true })
    onUrlChange(changedRoute: any) {
        if (changedRoute && changedRoute.name === 'applicationSummary') {
            const self = this;
            if (this.application && this.$route.params.applicationId) {
                this.id = Number(this.$route.params.applicationId);
                this.tagReviews = [];
                this.getAppData();  
            }
        }
    }

}
